import script from "./e_book.vue?vue&type=script&setup=true&lang=js"
export * from "./e_book.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__